export const ECHARTS_THEME = {
  color: [
    'hsl(221, 83%, 53%)',
    'hsl(142, 71%, 45%)',
    'hsl(25, 95%, 53%)',
    'hsl(280, 60%, 55%)',
    'hsl(340, 75%, 55%)',
    'hsl(180, 60%, 45%)',
    'hsl(45, 90%, 50%)',
    'hsl(0, 70%, 55%)',
  ],
  backgroundColor: 'transparent',
  textStyle: { fontFamily: 'inherit' },
  title: {
    textStyle: { fontSize: 14, fontWeight: 600 },
  },
  line: {
    itemStyle: { borderWidth: 2 },
    lineStyle: { width: 2 },
    symbolSize: 6,
    symbol: 'circle',
    smooth: false,
  },
  bar: {
    itemStyle: { barBorderRadius: [4, 4, 0, 0] },
  },
  pie: {
    itemStyle: { borderWidth: 0 },
  },
  categoryAxis: {
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: { fontSize: 11, color: '#888' },
    splitLine: {
      show: true,
      lineStyle: { type: 'dashed', color: 'rgba(128,128,128,0.2)' },
    },
  },
  valueAxis: {
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: { fontSize: 11, color: '#888' },
    splitLine: {
      show: true,
      lineStyle: { type: 'dashed', color: 'rgba(128,128,128,0.2)' },
    },
  },
  tooltip: {
    backgroundColor: 'rgba(15, 15, 15, 0.95)',
    borderColor: 'hsl(22 93% 58% / 0.25)',
    borderWidth: 1,
    textStyle: { color: '#e5e5e5', fontSize: 12 },
    // Subtle orange glow to match the in-app filter-popout-glow convention.
    extraCssText:
      'border-radius: 8px; padding: 8px 12px; box-shadow: 0 0 0 1px hsl(22 93% 58% / 0.10), 0 4px 20px -4px hsl(22 93% 58% / 0.15), 0 0 32px -10px hsl(22 93% 58% / 0.18);',
  },
};
